import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { RadiantSpinner } from 'components/RadiantSpinner'

import { PinnedNote } from 'modules/unsubscribe/components/PinnedNote'
import { useContinuedPlan } from 'modules/unsubscribe/pages/ContinuedPlan/useContinuedPlan'

import { FlowButton } from '../../components/FlowButton'
import { FlowPageContainer } from '../../components/FlowPageContainer'
import { useRetentionFlowV2Config } from '../../hooks/useRetentionFlowV2Config'
import { FlowBottomArea, FlowContent, FlowOutcomeTitle } from '../../styles'

export const FlowContinuedPlan: React.FC = () => {
  const { t } = useTranslation()
  const { appName, copyKey } = useRetentionFlowV2Config()
  const { isInProgress, goToAccountPage } = useContinuedPlan()

  return (
    <FlowPageContainer>
      {isInProgress ? (
        <FlowContent>
          <FlowOutcomeTitle>
            {t('retention.continuedPlan.step1Title')}
          </FlowOutcomeTitle>
          <RadiantSpinner />
        </FlowContent>
      ) : (
        <>
          <FlowContent>
            <FlowOutcomeTitle>
              {t('retention.continuedPlan.step2Title', {
                context: appName,
              })}
            </FlowOutcomeTitle>
            <PinnedNote>
              <Trans i18nKey={`${copyKey}.continuedPlan.note`} />
            </PinnedNote>
          </FlowContent>
          <FlowBottomArea isFixed>
            <FlowButton type="button" onClick={goToAccountPage}>
              {t(`${copyKey}.continuedPlan.okButton`)}
            </FlowButton>
          </FlowBottomArea>
        </>
      )}
    </FlowPageContainer>
  )
}
